import React from 'react';
import { withTranslation } from "react-i18next";

class Error extends React.Component {
  constructor(props) {
    super(props);
    var { i18n } = props;
    if(props.match && props.match.params && props.match.params.language) {
      i18n.changeLanguage(props.match.params.language);
    }
  }

  render() {
    var { t } = this.props;
    return (
        <div>
          <div className="errorImage">
            <img alt="Error" src="/images/img-404-error.png" srcSet="/images/img-404-error@2x.png 2x,/images/img-404-error@3x.png 3x"/>
          </div>
          <div className="errorTitle">{t('notificationErrorMessage')}</div>
        </div>
    );
  }
}

export default withTranslation()(Error);